
const formatter = new Intl.NumberFormat('hr-HR', {
    style: 'currency',
    currency: 'EUR',
});

export const formatCurrency = (value: number) => formatter.format(value);
